import { ref, onMounted, onUnmounted, computed } from 'vue';
import _ from 'lodash';

export function useTableResize(columnFreezing: boolean) {
  const generatedTableID = ref(_.uniqueId('table_'));
  const tableDimensions = ref({ scrollWidth: 0, clientWidth: 0 });
  const tableContainer = ref<HTMLElement | null>(null);
  let observer: ResizeObserver | null = null;

  const showFreeze = computed(() => {
    if (columnFreezing) {
      return (
        tableDimensions.value.scrollWidth > tableDimensions.value.clientWidth
      );
    }
    return false;
  });

  onMounted(() => {
    tableContainer.value = document.querySelector(
      `.${generatedTableID.value}`
    ) as HTMLElement;
    if (!tableContainer.value) return;
    const tableElement = tableContainer.value.querySelector('table');
    observer = new ResizeObserver(() => {
      tableDimensions.value = {
        scrollWidth: tableElement!.clientWidth,
        clientWidth: tableContainer.value!.clientWidth,
      };
    });
    observer.observe(tableContainer.value);
    // Initial assignment
    tableDimensions.value = {
      scrollWidth:
        tableElement?.clientWidth ?? tableContainer.value.scrollWidth,
      clientWidth: tableContainer.value.clientWidth,
    };
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  return { generatedTableID, showFreeze };
}
